import { useMutation } from "@tanstack/react-query";
import { ContactPayload, ContactResponse, LoginData, LoginResponse, UserDto } from "./type";
import { loginUser, sendContact } from "./api";
import { AxiosError } from "axios";

export const useContact = () => {
    return useMutation<ContactResponse, AxiosError, ContactPayload>({
        mutationFn: sendContact, // Fonction qui effectue le POST
        retry: 2, // Réessaie 2 fois en cas d'échec
    });
};